import api from './api.service';

export default {
    getNoteTags(companyId, relatedTo) {
        return api.get(
            `/company/note-tags?companyId=${companyId}&relatedTo=${encodeURIComponent(relatedTo)}`
        );
    },
    createNoteTag(data) {
        return api.post('/company/note-tags', {
            ...data,
            relatedTo: data.relatedTo || data.entityType
        });
    },
    updateNoteTag(id, data) {
        return api.put(`/company/note-tags/${id}`, data);
    },
    deleteNoteTag(id, companyId) {
        return api.delete(`/company/note-tags/${id}?companyId=${companyId}`);
    }
};
